import { SelectOption } from 'components/AGSelect/AGSimpleSelect/AGSimpleSelect';

export type ComparePeriod = '4w' | '3m' | '6m' | '12m';

export const comparePeriodOptions: SelectOption[] = [
    { value: '4w', label: 'Last 4 Weeks' },
    { value: '3m', label: 'Last 3 Months' },
    { value: '6m', label: 'Last 6 Months' },
    { value: '12m', label: 'Last 12 Months' },
];

export function getAvgSinceTimestamp(comparePeriod: ComparePeriod, currentDate = new Date()) {
    const date = new Date(currentDate);
    if (comparePeriod === '4w') {
        date.setDate(date.getDate() - 28);
    } else if (comparePeriod === '3m') {
        date.setMonth(date.getMonth() - 3);
    } else if (comparePeriod === '6m') {
        date.setMonth(date.getMonth() - 6);
    } else {
        date.setMonth(date.getMonth() - 12);
    }
    return Math.floor(date.getTime() / 1000);
}
